module.exports = __webpack_public_path__ + "img/page1.fca64134.png";